<template>
	<div class="skrzynia" v-show="show">
		<div class="stitle"> {{ title }} </div>
		<div>
			<div class="nazwa"> {{ nazwa }} </div>
			<div class='wrap'>
    				<ejs-numerictextbox :id="getIdSkrzyni()" :value="skr" format="###" :min="0" cssClass="e-style"></ejs-numerictextbox>
			</div>
		</div>
		<div>
                        <button :class="getClass(1)"> 1 </button>
                        <button :class="getClass(2)"> 2 </button>
                        <button :class="getClass(3)"> 3 </button>
                </div>
	</div>
</template>

<script>

import { NumericTextBoxComponent } from "@syncfusion/ej2-vue-inputs";
import "../../node_modules/@syncfusion/ej2-base/styles/material.css";
import "../../node_modules/@syncfusion/ej2-vue-inputs/styles/material.css";

export default {
  name: "skrzyniawydanie",
  components: { 
        "ejs-numerictextbox": NumericTextBoxComponent,
  },
  props: {
    nazwa: String,
    ident: Number,
    dataLoading: Boolean,
  },
  data: () => ({
        title: "PODAJ ILOŚĆ SKRZYŃ",
	show: false,
	skr: 0,
  }),
  methods: {
	getIdSkrzyni() {
		return "skrzynia" + this.ident;
	},
	selectSkr(val1) {
                this.skr = Number(val1);
        },
	getClass(txt) {
		return "" + this.getIdSkrzyni() + " do_wagi" + txt;
	},
  },
  mounted() {
	let that = this;
    	this.$root.$on("update:skrzynia", val1 => {
		if (val1 != null) {
			var vals = new String(val1);
			var ids = vals.split(",");
			//console.log("IDS: " + ids);
			//console.log("IDENT:" + that.ident);
			if (ids.includes("" + that.ident)) {
				console.log("FOUND!");
				that.show = true;
			} else {
				that.show = false;
			}
		}
    	});
	document.querySelector("." + this.getIdSkrzyni() + ".do_wagi1").addEventListener('click', function() { that.selectSkr('1'); } );
        document.querySelector("." + this.getIdSkrzyni() + ".do_wagi2").addEventListener('click', function() { that.selectSkr('2'); } );
        document.querySelector("." + this.getIdSkrzyni() + ".do_wagi3").addEventListener('click', function() { that.selectSkr('3'); } );
  }
} 

</script>

<style>

.e-numeric.e-style .e-control.e-numerictextbox {
        color: royalblue;
        font-size: xx-large;
        border: 0px;
    }

/* csslint ignore:start */
    .e-numeric .e-input-group-icon.e-spin-up:before {
        content: "\e823";
        color: rgba(0, 0, 0, 0.54);
    }

    .e-numeric .e-input-group-icon.e-spin-down:before {
        content: "\e934";
        color: rgba(0, 0, 0, 0.54);
    }
    /* csslint ignore:end */

.skrzynia {
	margin-bottom:5%;
}

.nazwa {
}

.stitle {
	color:red;
}

.wrap {
margin: 0 auto;
width: 240px;
}
.do_wagi {
        width: 100px;
        height: 50px;
}

.do_wagi1,.do_wagi2,.do_wagi3 {
        width: 50px;
        height: 50px;
        margin-right: 20px;
}

</style>




// WEBPACK FOOTER //
// src/components/SkrzyniaWydanie.vue